import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import type { ILegendItems } from "app/components/React/Legends/legendsTypes";
import type { Records } from "app/pages/industry-analysis/players/market-shares/types";
import type { ICustomSegmentAccount } from "app/services/segments/segmentsApiService";
import { fetchWebsitesFaviconsQuery } from "app/services/sitesService/queries/sitesQueries";

import { SEGMENT_ID, WEBSITE_ID } from "../segments/constants";

import { MAX_ITEMS_SELECTED } from "./constants";
import type { Domain, SelectedWebsites } from "./types";

export const getDomainsArray = (response: Records): string[] => {
    const result = [];

    response.forEach((item) => {
        result.push(item.Id);
    });

    return result;
};

const getSelectedKeysArray = (keys: ILegendItems): string[] => {
    const result = [];

    keys.forEach((key) => {
        if (key.visible) {
            result.push(key.id);
        }
    });

    return result;
};

export const getIndustryItemText = (item: IFlattenedCategory) => {
    let text;

    if (item?.getText) {
        text = item.getText();
    } else {
        text = item.text;
    }

    return text;
};

const getSegmentsMetaMap = (segmentsMeta: ICustomSegmentAccount[]) => {
    const map = new Map();

    if (segmentsMeta?.length) {
        segmentsMeta.forEach((item) => {
            map.set(item.id, item);
        });
    }

    return map;
};

export const createWebsitesItems = async (
    data: string[],
    keys: ILegendItems,
    segmentsMeta: ICustomSegmentAccount[],
) => {
    const selectedDomains: Domain[] = [];
    const domainsList: Domain[] = [];

    const selectedKeysArray = getSelectedKeysArray(keys);
    const selectedWebsites: SelectedWebsites = {
        ids: {},
        size: 0,
    };
    const segmentsMetaMap = getSegmentsMetaMap(segmentsMeta);

    if (data?.length) {
        const images = await fetchWebsitesFaviconsQuery(data);

        data.forEach((item, index) => {
            let isVisible = false;

            const currentSegmentMeta = segmentsMetaMap.get(item);
            const { domain, segmentName, type, itemImage } = {
                domain: currentSegmentMeta ? currentSegmentMeta.domain : item,
                segmentName: currentSegmentMeta?.segmentName,
                type: currentSegmentMeta ? SEGMENT_ID : WEBSITE_ID,
                itemImage: currentSegmentMeta ? currentSegmentMeta.favicon : images[item],
            };

            if (selectedKeysArray?.length > 0) {
                const isSelected = selectedKeysArray.includes(item);

                if (isSelected) {
                    selectedWebsites.ids[item] = true;
                    selectedWebsites.size = selectedWebsites.size + 1;

                    isVisible = true;
                }
            } else {
                if (index + 1 <= MAX_ITEMS_SELECTED) {
                    selectedWebsites.ids[item] = true;
                    selectedWebsites.size = selectedWebsites.size + 1;

                    isVisible = true;
                }
            }

            if (isVisible) {
                selectedDomains.push({
                    id: item,
                    visible: isVisible,
                    domain,
                    segmentName,
                    image: itemImage,
                    type,
                });
            }

            domainsList.push({
                id: item,
                visible: isVisible,
                domain,
                segmentName,
                image: itemImage,
                type,
            });
        });
    }

    return {
        domainsList,
        selectedDomains,
        selectedWebsites,
    };
};
